import { render, staticRenderFns } from "./GenConfigBlock.vue?vue&type=template&id=4a69cb41&scoped=true"
import script from "./GenConfigBlock.vue?vue&type=script&lang=js"
export * from "./GenConfigBlock.vue?vue&type=script&lang=js"
import style0 from "./GenConfigBlock.vue?vue&type=style&index=0&id=4a69cb41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a69cb41",
  null
  
)

export default component.exports